import { render, staticRenderFns } from "./BranchSelector.vue?vue&type=template&id=2b68a5d2"
import script from "./BranchSelector.vue?vue&type=script&lang=js"
export * from "./BranchSelector.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports